export var Role;
(function (Role) {
    // Organization-level roles (establishment membership used for data filtering)
    Role["ORG_OWNER"] = "ORG_OWNER";
    Role["ORG_ADMINISTRATOR"] = "ORG_ADMINISTRATOR";
    Role["ORG_MANAGER"] = "ORG_MANAGER";
    Role["ORG_MEDICAL_PROFESSIONAL"] = "ORG_MEDICAL_PROFESSIONAL";
    Role["ORG_ACCOUNTANT"] = "ORG_ACCOUNTANT";
    Role["ORG_VIEWER"] = "ORG_VIEWER";
    Role["ORG_INSTRUCTOR_CALENDAR_ONLY"] = "ORG_INSTRUCTOR_CALENDAR_ONLY";
    Role["ORG_NO_ACCESS"] = "ORG_NO_ACCESS";
})(Role || (Role = {}));
// ============================================================================
// UNIFIED CAPABILITY-BASED RBAC
// ============================================================================
export var Action;
(function (Action) {
    // Organization governance
    Action["VIEW_SETTINGS"] = "VIEW_SETTINGS";
    Action["MANAGE_SETTINGS"] = "MANAGE_SETTINGS";
    Action["DELETE_ORGANIZATION"] = "DELETE_ORGANIZATION";
    // Staff & Establishments
    Action["VIEW_STAFF"] = "VIEW_STAFF";
    Action["MANAGE_STAFF"] = "MANAGE_STAFF";
    Action["INVITE_STAFF"] = "INVITE_STAFF";
    Action["VIEW_ESTABLISHMENTS"] = "VIEW_ESTABLISHMENTS";
    Action["MANAGE_ESTABLISHMENTS"] = "MANAGE_ESTABLISHMENTS";
    // Customers & Plans
    Action["VIEW_CUSTOMERS"] = "VIEW_CUSTOMERS";
    Action["MANAGE_CUSTOMERS"] = "MANAGE_CUSTOMERS";
    Action["IMPORT_CUSTOMERS"] = "IMPORT_CUSTOMERS";
    Action["EXPORT_CUSTOMERS"] = "EXPORT_CUSTOMERS";
    Action["VIEW_CUSTOMER_PLANS"] = "VIEW_CUSTOMER_PLANS";
    Action["MANAGE_CUSTOMER_PLANS"] = "MANAGE_CUSTOMER_PLANS";
    // Medical records
    Action["VIEW_MEDICAL_RECORDS"] = "VIEW_MEDICAL_RECORDS";
    Action["MANAGE_MEDICAL_RECORDS"] = "MANAGE_MEDICAL_RECORDS";
    Action["DELETE_MEDICAL_RECORDS"] = "DELETE_MEDICAL_RECORDS";
    // Finance
    Action["VIEW_BILLING"] = "VIEW_BILLING";
    Action["MANAGE_BILLING"] = "MANAGE_BILLING";
    Action["VIEW_PAYMENTS"] = "VIEW_PAYMENTS";
    Action["CREATE_PAYMENTS"] = "CREATE_PAYMENTS";
    Action["MANAGE_PAYMENTS"] = "MANAGE_PAYMENTS";
    // Establishment operational actions
    Action["VIEW_SCHEDULES"] = "VIEW_SCHEDULES";
    Action["MANAGE_SCHEDULES"] = "MANAGE_SCHEDULES";
    Action["VIEW_SCHEDULE_SESSIONS"] = "VIEW_SCHEDULE_SESSIONS";
    Action["MANAGE_SCHEDULE_SESSIONS"] = "MANAGE_SCHEDULE_SESSIONS";
    Action["VIEW_ATTENDANCE"] = "VIEW_ATTENDANCE";
    Action["MANAGE_ATTENDANCE"] = "MANAGE_ATTENDANCE";
    Action["VIEW_ENROLLMENTS"] = "VIEW_ENROLLMENTS";
    Action["MANAGE_ENROLLMENTS"] = "MANAGE_ENROLLMENTS";
    // Notifications
    Action["VIEW_NOTIFICATIONS"] = "VIEW_NOTIFICATIONS";
    Action["MANAGE_NOTIFICATIONS"] = "MANAGE_NOTIFICATIONS";
    // Analytics
    Action["VIEW_ANALYTICS"] = "VIEW_ANALYTICS";
    // Organization Management reports
    Action["VIEW_FINANCIAL_ANALYSIS"] = "VIEW_FINANCIAL_ANALYSIS";
    Action["VIEW_CUSTOMER_RISK_ANALYSIS"] = "VIEW_CUSTOMER_RISK_ANALYSIS";
    Action["VIEW_COST_MANAGEMENT"] = "VIEW_COST_MANAGEMENT";
    Action["MANAGE_COST_MANAGEMENT"] = "MANAGE_COST_MANAGEMENT";
    // Audit
    Action["VIEW_AUDIT_LOGS"] = "VIEW_AUDIT_LOGS";
})(Action || (Action = {}));
export var Scope;
(function (Scope) {
    Scope["ORG"] = "ORG";
})(Scope || (Scope = {}));
// ----------------------------------------------------------------------------
// DEFAULT ROLE DEFINITIONS (mapped from current OrganizationRole/EstablishmentRole)
// ----------------------------------------------------------------------------
export const DEFAULT_ROLE_DEFINITIONS = [
    // Organization-level roles
    {
        id: Role.ORG_OWNER,
        name: "Organization Owner",
        grants: [
            { action: Action.VIEW_SETTINGS, scope: Scope.ORG },
            { action: Action.MANAGE_SETTINGS, scope: Scope.ORG },
            { action: Action.DELETE_ORGANIZATION, scope: Scope.ORG },
            { action: Action.VIEW_STAFF, scope: Scope.ORG },
            { action: Action.MANAGE_STAFF, scope: Scope.ORG },
            { action: Action.INVITE_STAFF, scope: Scope.ORG },
            { action: Action.VIEW_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMERS, scope: Scope.ORG },
            { action: Action.MANAGE_CUSTOMERS, scope: Scope.ORG },
            { action: Action.IMPORT_CUSTOMERS, scope: Scope.ORG },
            { action: Action.EXPORT_CUSTOMERS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.MANAGE_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.VIEW_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULES, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULES, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.VIEW_ATTENDANCE, scope: Scope.ORG },
            { action: Action.MANAGE_ATTENDANCE, scope: Scope.ORG },
            { action: Action.VIEW_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.MANAGE_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.DELETE_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.VIEW_BILLING, scope: Scope.ORG },
            { action: Action.MANAGE_BILLING, scope: Scope.ORG },
            { action: Action.VIEW_PAYMENTS, scope: Scope.ORG },
            { action: Action.CREATE_PAYMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_PAYMENTS, scope: Scope.ORG },
            { action: Action.VIEW_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.MANAGE_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.VIEW_ANALYTICS, scope: Scope.ORG },
            { action: Action.VIEW_FINANCIAL_ANALYSIS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_RISK_ANALYSIS, scope: Scope.ORG },
            { action: Action.VIEW_COST_MANAGEMENT, scope: Scope.ORG },
            { action: Action.MANAGE_COST_MANAGEMENT, scope: Scope.ORG },
            { action: Action.VIEW_AUDIT_LOGS, scope: Scope.ORG },
        ],
    },
    {
        id: Role.ORG_ADMINISTRATOR,
        name: "Organization Administrator",
        grants: [
            { action: Action.VIEW_SETTINGS, scope: Scope.ORG },
            { action: Action.MANAGE_SETTINGS, scope: Scope.ORG },
            { action: Action.VIEW_STAFF, scope: Scope.ORG },
            { action: Action.MANAGE_STAFF, scope: Scope.ORG },
            { action: Action.INVITE_STAFF, scope: Scope.ORG },
            { action: Action.VIEW_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMERS, scope: Scope.ORG },
            { action: Action.MANAGE_CUSTOMERS, scope: Scope.ORG },
            { action: Action.IMPORT_CUSTOMERS, scope: Scope.ORG },
            { action: Action.EXPORT_CUSTOMERS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.MANAGE_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.VIEW_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULES, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULES, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.VIEW_ATTENDANCE, scope: Scope.ORG },
            { action: Action.MANAGE_ATTENDANCE, scope: Scope.ORG },
            { action: Action.VIEW_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.MANAGE_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.VIEW_BILLING, scope: Scope.ORG },
            { action: Action.MANAGE_BILLING, scope: Scope.ORG },
            { action: Action.VIEW_PAYMENTS, scope: Scope.ORG },
            { action: Action.CREATE_PAYMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_PAYMENTS, scope: Scope.ORG },
            { action: Action.VIEW_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.MANAGE_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.VIEW_ANALYTICS, scope: Scope.ORG },
            { action: Action.VIEW_FINANCIAL_ANALYSIS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_RISK_ANALYSIS, scope: Scope.ORG },
            { action: Action.VIEW_COST_MANAGEMENT, scope: Scope.ORG },
            { action: Action.MANAGE_COST_MANAGEMENT, scope: Scope.ORG },
            { action: Action.VIEW_AUDIT_LOGS, scope: Scope.ORG },
        ],
    },
    {
        id: Role.ORG_MANAGER,
        name: "Organization Manager",
        grants: [
            { action: Action.VIEW_SETTINGS, scope: Scope.ORG },
            { action: Action.VIEW_STAFF, scope: Scope.ORG },
            { action: Action.MANAGE_STAFF, scope: Scope.ORG },
            { action: Action.INVITE_STAFF, scope: Scope.ORG },
            { action: Action.VIEW_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMERS, scope: Scope.ORG },
            { action: Action.MANAGE_CUSTOMERS, scope: Scope.ORG },
            { action: Action.IMPORT_CUSTOMERS, scope: Scope.ORG },
            { action: Action.EXPORT_CUSTOMERS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.MANAGE_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.VIEW_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULES, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULES, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.VIEW_ATTENDANCE, scope: Scope.ORG },
            { action: Action.MANAGE_ATTENDANCE, scope: Scope.ORG },
            { action: Action.VIEW_PAYMENTS, scope: Scope.ORG },
            { action: Action.CREATE_PAYMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_PAYMENTS, scope: Scope.ORG },
            { action: Action.VIEW_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.MANAGE_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.VIEW_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.VIEW_ANALYTICS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_RISK_ANALYSIS, scope: Scope.ORG },
        ],
    },
    {
        id: Role.ORG_MEDICAL_PROFESSIONAL,
        name: "Organization Medical Professional",
        grants: [
            { action: Action.VIEW_STAFF, scope: Scope.ORG },
            { action: Action.VIEW_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMERS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.VIEW_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULES, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULES, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.MANAGE_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.VIEW_ATTENDANCE, scope: Scope.ORG },
            { action: Action.MANAGE_ATTENDANCE, scope: Scope.ORG },
            { action: Action.VIEW_PAYMENTS, scope: Scope.ORG },
            { action: Action.CREATE_PAYMENTS, scope: Scope.ORG },
            { action: Action.VIEW_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.MANAGE_MEDICAL_RECORDS, scope: Scope.ORG },
            { action: Action.VIEW_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.VIEW_ANALYTICS, scope: Scope.ORG },
        ],
    },
    {
        id: Role.ORG_ACCOUNTANT,
        name: "Organization Accountant",
        grants: [
            { action: Action.VIEW_SETTINGS, scope: Scope.ORG },
            { action: Action.VIEW_BILLING, scope: Scope.ORG },
            { action: Action.MANAGE_BILLING, scope: Scope.ORG },
            { action: Action.VIEW_PAYMENTS, scope: Scope.ORG },
            { action: Action.CREATE_PAYMENTS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMERS, scope: Scope.ORG },
            { action: Action.VIEW_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.MANAGE_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.VIEW_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.VIEW_ANALYTICS, scope: Scope.ORG },
            { action: Action.VIEW_FINANCIAL_ANALYSIS, scope: Scope.ORG },
            { action: Action.VIEW_COST_MANAGEMENT, scope: Scope.ORG },
        ],
    },
    {
        id: Role.ORG_VIEWER,
        name: "Organization Viewer",
        grants: [
            { action: Action.VIEW_ESTABLISHMENTS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMERS, scope: Scope.ORG },
            { action: Action.VIEW_CUSTOMER_PLANS, scope: Scope.ORG },
            { action: Action.VIEW_ENROLLMENTS, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULES, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.VIEW_ATTENDANCE, scope: Scope.ORG },
            { action: Action.VIEW_PAYMENTS, scope: Scope.ORG },
            { action: Action.VIEW_NOTIFICATIONS, scope: Scope.ORG },
            { action: Action.VIEW_ANALYTICS, scope: Scope.ORG },
        ],
    },
    {
        id: Role.ORG_INSTRUCTOR_CALENDAR_ONLY,
        name: "Instructor (Calendar Only)",
        grants: [
            { action: Action.VIEW_SCHEDULES, scope: Scope.ORG },
            { action: Action.VIEW_SCHEDULE_SESSIONS, scope: Scope.ORG },
            { action: Action.VIEW_ATTENDANCE, scope: Scope.ORG },
            { action: Action.VIEW_STAFF, scope: Scope.ORG },
        ],
    },
    {
        id: Role.ORG_NO_ACCESS,
        name: "No Access",
        grants: [],
    },
];
//# sourceMappingURL=Authorization.js.map